var _style, _g, _g2, _polyline;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionGraphicsBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#FFFFFF;stroke:#000000;stroke-width:15;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:15;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#000000;stroke-width:32;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#000000;stroke-width:12;stroke-miterlimit:16;stroke-dasharray:36.4575,36.4575;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000174598911272282734860000016596018749225247873_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M540,61.6L281.2,584l128.7,168.3c15.7,20.5,24.2,45.7,24.2,71.5v193.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M540,61.6L798.8,584L670.1,752.3c-15.7,20.5-24.2,45.7-24.2,71.5v193.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 540,
    y1: 24,
    x2: 540,
    y2: 593.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -253.0909 552.1843)",
    cx: 540,
    cy: 581.6,
    rx: 42.9,
    ry: 42.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 365.9,
    y1: 899.2,
    x2: 711.8,
    y2: 899.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.3,
    y: 899.2,
    width: 150.6,
    height: 117.6
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000047742057499015264330000015150996534852115643_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1023.8,807.1l-40.1,0.4c-19.5,0.2-38-8.4-50.5-23.3l-15.6-18.8c-24.6-29.5-69.3-31.3-96.1-3.8l-40.2,41.1 c-28.4,29.1-76.3,25.1-99.5-8.3l-34.1-49c-25.2-36.2-78.5-37.2-105-1.9l-39.4,52.3c-24.5,32.6-72.7,34.7-100,4.4l-28-31.1 c-24-26.7-65.2-28.8-91.8-4.6l-17.4,15.8c-27.5,25-70.3,21.8-93.8-6.9l0,0c-12.3-15-30.7-23.8-50.2-23.8h-32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 99.4,
    y1: 899.2,
    x2: 611.2,
    y2: 899.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 586.4,
    y1: 964.2,
    x2: 1023.8,
    y2: 964.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M833,584.9H247c-63.9,0-115.8-51.8-115.8-115.8v-286c0-63.9,51.8-115.8,115.8-115.8h586 c63.9,0,115.8,51.8,115.8,115.8v286C948.8,533,897,584.9,833,584.9z"
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "202,244 440.3,444.4 871,262 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionGraphicsBackground);
export default __webpack_public_path__ + "static/media/Motion-Graphics-Background.4e9567347b93ef3852e9ccce49e3ef72.svg";
export { ForwardRef as ReactComponent };